import type { SpecSectionField } from './SpecSection.types';
import { SpecSectionItem } from './SpecSectionItem';

import styles from './SpecSection.module.scss';

interface SpecSectionProps<T> {
	data: T;
	fields: SpecSectionField<T>[];
	isPrint?: boolean;
	shouldHideSensitive?: boolean;
}

export const SpecSection = <T,>({
	data,
	fields,
	isPrint,
	shouldHideSensitive = false,
}: SpecSectionProps<T>): JSX.Element => {
	return (
		<div className={styles.container} data-dd-privacy={shouldHideSensitive ? 'mask' : 'allow'}>
			{fields.map((field) => (
				<SpecSectionItem key={field.fieldName.toString()} {...field} data={data} isPrint={isPrint} />
			))}
		</div>
	);
};
